import { Component, Input } from '@angular/core';

export enum StatusIndicatorKinds {
  YELLOW = 'yellow',
  RED = 'red',
  GREEN = 'green',
  PENDING = 'pending',
  DEFAULT = 'default',
  ORANGE = 'orange',
  COMPLETED = 'completed',
  COMPLETED_BLUE = 'completed-blue',
  UNIDENTIFIED = 'unidentified',
  FAILED = 'failed',
  ARCHIVED = 'archived',
  PAUSED = 'paused',
}

@Component({
  selector: 'cm-status-indicator',
  templateUrl: './status-indicator.component.html',
  styleUrls: ['./status-indicator.component.scss'],
})
export class StatusIndicatorComponent {
  @Input() kind: StatusIndicatorKinds;
  @Input() tooltip: string;
}
